import gql from 'graphql-tag';

export default gql`
  fragment prospectCustomizeItemTextFragment on ProspectCustomizeItemText {
    id
    value
    poolProspectCustomizeItemId
  }
`;
